export const SHOW_QUESTIONNAIRE_MODAL = 'SHOW_QUESTIONNAIRE_MODAL';
export const CLOSE_QUESTIONNAIRE_MODAL = 'CLOSE_QUESTIONNAIRE_MODAL';